import { Component, HostListener, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { AuthorService } from 'src/app/services/author.service';
import { FileService } from 'src/app/services/file.service';
import { AlertController, ModalController } from '@ionic/angular';
import { UnsavedSceneService } from 'src/app/services/unsaved-scene.service';
import { VrEventService } from 'src/app/services/vr-event.service';
import { ApiVrEventService } from 'src/app/api-services/vr-event.api.service';
import { UnfocusElementService } from 'src/app/services/unfocus-element.service';
import { Scene } from 'src/app/models/Scene';
import { AssetInScene } from 'src/app/models/AssetInScene';
import { AddEventsModalPage } from '../add-events-modal/add-events-modal.page';
import { ValidationService } from 'src/app/services/validation.service';
import { MessagesService } from 'src/app/services/messages.service';
import { FileSizeService } from 'src/app/services/file-size.service';
import { SceneBackgroundModalPage } from '../scene-background-modal/scene-background-modal.page';
import { SceneEvent } from 'src/app/models/vr-events/SceneEvent';
import { VrEventTypeService } from 'src/app/services/vr-event-type.service';
import { MediaAsset } from 'src/app/models/assets/MediaAsset';
import { DeepCopyService } from 'src/app/services/deep-copy.service';
import { AssetManagementService } from 'src/app/services/asset-management.service';
import { ViewAssetModalPage } from '../view-asset-modal/view-asset-modal.page';
import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';

@Component({
  selector: 'app-scene-settings-modal',
  templateUrl: './scene-settings-modal.page.html',
  styleUrls: ['./scene-settings-modal.page.scss'],
})
export class SceneSettingsModalPage implements OnInit {

  private _isModalOpen: boolean = false;

  public scene: Scene;
  public editing: boolean;
  public backgroundRotationInterval = null;
  public sceneYRot: string = '0';
  public selectOptions: any;
  public paginateConfig: any;
  public backgroundUploaded: boolean = false;
  public backgroundUploadedFiles: any;
  public backgroundFromMediaManagementPage: boolean = false;
  public backgroundFileName: string = "";
  public backgroundIDToCopy: number = -1;
  public oldBackgroundIDToCopy: number = -1;
  public assetsOnAssetManagementPage: MediaAsset[] = [];
  public compressVideo: boolean = false;

  public addFromMediaManagementPage: boolean = false;
  public manageActions: boolean = false;
  public currentEventIndex: number = 0;
  public currentSceneEvents: SceneEvent[] = [];
  public sceneEvent: SceneEvent;
  public backgroundSearchTerm: string;
  public searchNotFound: boolean = false;

  public assetsOnAssetManagementPageList: MediaAsset[] = [];
  public assetsOnAssetManagementPageListCopy: MediaAsset[] = [];
  public video: any;
  public IonDateTimeHourValues: number[] = [0];
  public IonDateTimeMinuteValues: number[] = [0];

  public previewBackground: string = "background-image";
  public previewLoading: boolean = false;
  public previewReady: boolean = false;
  public videoPlaying: boolean = false;
  public cameraMovementTimeout = null;
  public moving: boolean = false;
  public sceneBackgroundTypeChanged: boolean = false;
  public moveCameraTimeout: any = null;

  public displayActions: boolean = false;
  public backgroundChanged: boolean = false;
  public applyToAllScenes: boolean = false;

  constructor(
    private sanitizer: DomSanitizer,
    public authorService: AuthorService,
    public fileService: FileService,
    public alertController: AlertController,
    public modalController: ModalController,
    public unsavedSceneService: UnsavedSceneService,
    public VrEventService: VrEventService,
    public VrEventAPIService: ApiVrEventService,
    public unfocusService: UnfocusElementService,
    public validationService: ValidationService,
    public messagesService: MessagesService,
    public fileSizeService: FileSizeService,
    public vrEventService: VrEventService,
    public vrEventTypeService: VrEventTypeService,
    public deepCopyService: DeepCopyService,
    public assetManagementService: AssetManagementService,
  ) {
    this.selectOptions = {
      cssClass: 'quizard-select'
    }    
    this.paginateConfig = {
      itemsPerPage: 4,
      currentPage: 1
    };
  }

  @HostListener('document:mouseup', ['$event'])
  onMouseUp(e) {
    this.setModalTransparency(1, e);
  }

  ngOnInit() {
    this.sceneYRot = ((Number(this.scene.yRot) * (-1)) + 360).toString();
    this.assetManagementService.getAssetsOnManagementPage().then(() => {
      this.assetsOnAssetManagementPage = this.assetManagementService.assets;
    });
    this.sceneEvent = this.vrEventService.getNewSceneEvent(this.scene);

    if(this.scene.sceneBackgroundFileType == 'Video')
      this.initialiseVideo();

    if(!this.displayActions && this.scene.sceneBackgroundSrc !== '')
      this.resetPreview();

    if(this.editing == false)
      this.backgroundChanged = true;
  }

  toggleModalTransparency(event) {
    var sceneSettingsModal = document.getElementById('scene-settings-modal');

    sceneSettingsModal.style.opacity = Number(sceneSettingsModal.style.opacity) != 0.3 ? '0.3' : '1';
  }

  setModalTransparency(opacity, event) {
    if(!this.editing) return;
    var sceneSettingsModal = document.getElementById('scene-settings-modal');
    sceneSettingsModal.style.opacity = opacity;
  }
  
  saveScene(event) {
    this.unfocusService.unfocus(event);
    this.scene.name = this.validationService.removeHtmlTags(this.scene.name);
    if (!this.validationService.isEmptyOrNull(this.scene.name)) {
      if(!this.editing){
        let input: any = document.querySelector('#scene-background-input');
        if(this.backgroundUploaded == true && (this.scene.sceneBackgroundFileType == 'Video' || this.scene.sceneBackgroundFileType == 'Image')) {
          this.fileService.replaceSceneBackgroundFile(input.files[0], '5a0ffb5a-475d-4307-bf05-237f82a9302d', this.compressVideo, "Uploading New Scene Background").then(async (srcResult) => {
            this.scene.sceneBackgroundSrc = srcResult;
            await this.authorService.addSceneToDb(this.scene);
  
            if(this.compressVideo){
              this.scene.uploadStatus = 'uploading';
              this.fileService.addVideoToCheckUploadStatus('scene', this.scene.sceneId, this.scene, srcResult);
              this.fileService.initialiseVideoUploadStatusCheck();
            }
            
            if(this.applyToAllScenes == true)
              this.applySceneBackgroundToAllScenes(this.scene);

            this.closeModal();
            this.messagesService.presentToast('Scene added successfully!', 'success', 'Authoring');          
          });
        }else{
          this.authorService.addSceneToDb(this.scene).then(() => {

            if(this.applyToAllScenes)
              this.applySceneBackgroundToAllScenes(this.scene);

            this.closeModal();
            this.messagesService.presentToast('Scene added successfully!', 'success', 'Authoring');          
          });
        }
      }else{
        this.authorService.scenes.forEach(async x => {
          if (x.sceneId == this.scene.sceneId) {
            let sceneSrcResult = this.scene.sceneBackgroundSrc;
            if(this.backgroundUploaded == true){
              sceneSrcResult = await this.uploadBackgroundFile();
            }
  
            x.name = this.validationService.removeHtmlTags(this.scene.name);
            x.description = this.scene.description;
            x.sceneBackgroundFileType = this.scene.sceneBackgroundFileType;
            x.sceneBackgroundSrc = sceneSrcResult;
            x.sceneBackgroundColour = this.scene.sceneBackgroundColour;
            x.sceneBackgroundFileSize = this.scene.sceneBackgroundFileSize;
            x.events = this.deepCopyService.deepCopy(this.scene.events);
            x.uploadStatus = this.scene.uploadStatus;
            x.xRot = this.scene.xRot;
            x.yRot = this.scene.yRot;
            
            let videoToCheck =this.fileService.getVideoToCheck('scene', x.sceneId)
            if(videoToCheck){
              x.uploadStatus = videoToCheck.uploadStatus;
              x.sceneBackgroundFileSize = videoToCheck.fileSize;
              x.sceneBackgroundSrc = videoToCheck.src;
            }
            
            this.authorService.updateSceneInDb(x);

            if(this.applyToAllScenes == true)
              this.applySceneBackgroundToAllScenes(x);
  
            this.closeModal();
            this.messagesService.presentToast('Scene saved successfully!', 'success', 'Authoring');
          }
        });

      }
    } else {
      this.alertForSceneName();
    }
  }

  applySceneBackgroundToAllScenes(scene: Scene){
    if(this.applyToAllScenes == true){
      for(let i = 0; i < this.authorService.scenes.length; i++){
        var _scene = this.authorService.scenes[i];
        if(_scene.sceneId == scene.sceneId)
          continue;

        _scene.sceneBackgroundColour = scene.sceneBackgroundColour;
        _scene.sceneBackgroundFileSize = scene.sceneBackgroundFileSize;
        _scene.sceneBackgroundFileType = scene.sceneBackgroundFileType;
        _scene.sceneBackgroundSrc = scene.sceneBackgroundSrc;
        _scene.uploadStatus = this.scene.uploadStatus;

        this.authorService.updateSceneInDb(_scene);
      }
    }
  }

  uploadBackgroundFile(): Promise<string>{
    return new Promise<string>((resolve) => {
      var file = this.backgroundUploadedFiles[0];
      var sceneId: number = this.authorService.currentScene.sceneId
  
      if (this.scene.sceneBackgroundFileType == "Image") {
        if (this.scene.sceneBackgroundSrc != null) {
          this.authorService.skyId = "#pano-blank";
          let title = "Uploading " + this.scene.name + " Background Image";
          this.fileService.replaceSceneBackgroundFile(file, '5a0ffb5a-475d-4307-bf05-237f82a9302d', false, title).then(async (srcResult) => {
            resolve(srcResult);
          });
        }
      }
      else if (this.validationService.uploadedFileType == "Video") {
        if (this.scene.sceneBackgroundSrc != null) {
          this.authorService.skyId = '#pano-blank';
          let title = "Uploading " + this.scene.name + " Background Video";
          if (this.compressVideo) {
            this.fileService.replaceSceneBackgroundFile(file, '5a0ffb5a-475d-4307-bf05-237f82a9302d', true, title).then((srcResult) => {
              let scene = this.scene;
              scene.uploadStatus = 'uploading';
              this.fileService.addVideoToCheckUploadStatus('scene', sceneId, scene, srcResult);
              this.fileService.initialiseVideoUploadStatusCheck();
              resolve(this.fileService.videoAssetUploadingPlaceholder);
            });
          }
          else {
            let title = "Uploading " + this.scene.name + " Background Video";
            this.fileService.replaceSceneBackgroundFile(file, '5a0ffb5a-475d-4307-bf05-237f82a9302d', false, title).then(async (srcResult) => {
              this.scene.uploadStatus = 'complete';
              resolve(srcResult);
            });
          }
        }
      }
    });
  }

  async alertForSceneName() {
    const alert = await this.alertController.create({
      header: 'Scene Name Required',
      buttons: [{
        text: 'Ok',
      }
      ]
    });
    await alert.present();
  }

  initBackgroundRotationInterval(valueToApply: number) {
    this.moving = true;
    this.backgroundRotationInterval = setInterval(() => {
      this.changeBackgroundRotation(valueToApply);
    }, 10);
  }

  clearBackgroundRotationInterval() {
    this.moving = false;
    if (this.backgroundRotationInterval) {
      clearInterval(this.backgroundRotationInterval);
      this.backgroundRotationInterval = null;
    }
  }

  clearCameraMovementTimeout() {
    if (this.cameraMovementTimeout) {
      clearTimeout(this.cameraMovementTimeout);
      this.cameraMovementTimeout = null;
    }
  }

  changeBackgroundRotation(value: number) {
    let y: number = Number(this.sceneYRot);
    y += value;

    this.sceneYRot = String(y);
  }

  updateBackgroundRotation(){
    let y: number = 0;

    y = Number(this.sceneYRot);
    
    if(y > 360) y = y - 360;
    if(y < 0) y = y + 360;

    this.sceneYRot = String(y);
    y = 360 - y;
    
    this.scene.yRot = String(y);

    this.clearCameraMovementTimeout();

    this.cameraMovementTimeout = setTimeout(() => {
      if(this.moving == false){
        this.authorService.moveCameraTo(0, y, 'author-scene'); // Move the camera to initial position
      }
    }, 1000);
  }

  validatePlaneColour(event) {
    if (this.scene.sceneBackgroundColour.trim().length == 0) {
      this.scene.sceneBackgroundColour = "#dddddd";
    }
  }

  closeModal() {
    this.modalController.dismiss();
  }

  setSceneYRotValue(){
    this.sceneYRot = String(360 - Number(this.authorService.currentScene.yRot));
  }

  cancel() {
    this.modalController.dismiss();
  }

  goBack(){
    this.manageActions = false;
    this.addFromMediaManagementPage = false;
    this.backgroundIDToCopy = this.oldBackgroundIDToCopy;
  }

  previewScene(){
    let scenePreview = document.querySelector('#scene-preview');
  }

  manageSceneActions(){
    if(!this.video) return;
    
    this.currentEventIndex = -1;
    this.currentSceneEvents = this.deepCopyService.deepCopy(this.scene.events);
    this.manageActions = true;
    setTimeout(() => this.resetSceneEvent(), 100);
  }

  resetSceneEvent(){
    this.currentEventIndex = -1;
    this.sceneEvent = this.vrEventService.getNewSceneEvent(this.scene);
    this.setTimeOfEvent();
  }

  setTimeOfEvent(){
    var timeFormatted = this.authorService.formatCurrentTime(this.sceneEvent.timeOfEvent, this.video.duration);
    var hoursDuration = this.video.duration / 60 / 60;
    if (hoursDuration < 1) {
      timeFormatted = "00:" + timeFormatted;
    }
    document.getElementById('video-current-time-picker').setAttribute('index', (-1).toString());
    document.getElementById('video-current-time-picker').setAttribute('value', timeFormatted);
    document.getElementById('video-current-time-picker').setAttribute('index', '0');

  }

  backgroundTypeChanged(event){
    this.backgroundChanged = true;
    this.backgroundUploaded = false;
    this.scene.sceneBackgroundSrc = '';
    this.scene.sceneBackgroundFileSize = 0;
    this.clearPreview();
  }

  async selectBackground() {
    let input = document.querySelector('#scene-background-input');

    const alert = await this.alertController.create({
      header: 'Choose ' + this.scene.sceneBackgroundFileType + ' Media',
      message: 'You can browse for a file on your computer or select a file from the media management page.',
      cssClass: 'leave-alert quizard-alert',
      buttons: [{
        text: 'Add ' + this.scene.sceneBackgroundFileType + ' from media management page',
        cssClass: '',
        handler: async () => {
          this.addFromMediaManagementPage = true;
          this.oldBackgroundIDToCopy = this.backgroundIDToCopy;
          switch (this.scene.sceneBackgroundFileType) {
            case 'Image': {
              this.assetsOnAssetManagementPageList = this.deepCopyService.deepCopy(this.assetsOnAssetManagementPage.filter((x: any) => x.isBackground == "true" && x.assetTypeId == 4));
              this.assetsOnAssetManagementPageListCopy = this.deepCopyService.deepCopy(this.assetsOnAssetManagementPage.filter((x: any) => x.isBackground == "true" && x.assetTypeId == 4));
              break;
            }
            case 'Video': {
              this.assetsOnAssetManagementPageList = this.deepCopyService.deepCopy(this.assetsOnAssetManagementPage.filter((x: any) => x.isBackground == "true" && x.assetTypeId == 5));
              this.assetsOnAssetManagementPageListCopy = this.deepCopyService.deepCopy(this.assetsOnAssetManagementPage.filter((x: any) => x.isBackground == "true" && x.assetTypeId == 5));
              break;
            }
          }
        }
      }, {
        text: 'Upload from computer',
        cssClass: '',
        handler: () => {
          if (input) {
            input.click();
          }
        }
      }
      ]
    });
    await alert.present();
  }

  searchByBackground(event) {
    let name: string = event.target.value ? event.target.value : '';

    this.assetsOnAssetManagementPageList = this.deepCopyService.deepCopy(this.assetsOnAssetManagementPageListCopy);
    var assets = this.assetsOnAssetManagementPageList.filter(x => x.name.toLowerCase().includes(name.toLowerCase()));
    if (assets.length === 0) {
      this.searchNotFound = true;
      this.assetsOnAssetManagementPageList = this.deepCopyService.deepCopy(this.assetsOnAssetManagementPageListCopy);
    }
    else {
      this.searchNotFound = false;
      this.assetsOnAssetManagementPageList = assets;
    }
  }

  backgroundFromComputerSelected(event) {
    let sceneToApply: any = this.scene;
    if (event.target.files.length == 0) return;
    this.validationService.setFileType(event);

    switch (this.scene.sceneBackgroundFileType) {
      case 'Image': {

        if (!this.validationService.doesUploadedFileMatchAssetType(4)) {
          this.validationService.createAlert('Wrong Media Type Uploaded.');
          return;
        } else if (!this.validationService.isFileFormatCorrect(4)) {
          this.validationService.createAlert('Unsupported File Format.');
          return;
        }

        this.backgroundFileName = String(event.target.files[0].name).substring(0, 40);
        sceneToApply.sceneBackgroundSrc = URL.createObjectURL(event.target.files[0]);
        sceneToApply.sceneBackgroundSrc = this.sanitizer.bypassSecurityTrustUrl(this.scene.sceneBackgroundSrc);
        this.backgroundIDToCopy = -1;
        this.backgroundUploaded = true;
        this.backgroundUploadedFiles = event.target.files;

        this.resetPreview();

        break;
      }
      case 'Video': {

        if (!this.validationService.doesUploadedFileMatchAssetType(5)) {
          this.validationService.createAlert('Wrong Media Type Uploaded.');
          return;
        } else if (!this.validationService.isFileFormatCorrect(5)) {
          this.validationService.createAlert('Unsupported File Format.');
          return;
        }

        this.backgroundFileName = String(event.target.files[0].name).substring(0, 40);
        sceneToApply.sceneBackgroundSrc = URL.createObjectURL(event.target.files[0]);
        sceneToApply.sceneBackgroundSrc = this.sanitizer.bypassSecurityTrustUrl(this.scene.sceneBackgroundSrc);
        this.backgroundIDToCopy = -1;
        this.backgroundUploaded = true;
        this.backgroundUploadedFiles = event.target.files;

        this.resetPreview();

        break;
      }
    }
  }

  async previewAsset(mediaAsset: any) {

    if (this._isModalOpen === true) return;
    this._isModalOpen = true;

    var oldSrc = mediaAsset.src;
    mediaAsset.src = this.sanitizer.bypassSecurityTrustUrl(oldSrc);

    const modal = await this.modalController.create({
      component: ViewAssetModalPage,
      id: 'asset-preview-' + this.scene.sceneBackgroundFileType + '-modal',
      componentProps: {
        "assetModalData": mediaAsset
      }
    });

    modal.onDidDismiss().then(() => {
      mediaAsset.src = oldSrc;
      this._isModalOpen = false;
    });

    return await modal.present();

  }

  saveSelectedBackground(){
    if (Number(this.backgroundIDToCopy) <= 0) {
      return;
    }

    let asset = this.assetsOnAssetManagementPage.find(a => a.baseAssetId == this.backgroundIDToCopy);
    this.scene.sceneBackgroundSrc = asset.src;
    this.scene.sceneBackgroundFileSize = asset.fileSize;
    this.backgroundFileName = asset.name;
    this.backgroundUploaded = false;

    this.goBack();
    this.resetPreview();
  }

  initialiseVideo() {
    this.video = document.querySelector('#scene-video');
    if (this.video) {
      this.video.onloadedmetadata = () => {
        this.formatIonDateTimeMaxValues();
      };
      if(this.displayActions)
        this.manageSceneActions();
    } else {
      setTimeout(() => { this.initialiseVideo() }, 200);
    }
  }

  formatIonDateTimeMaxValues() {
    var hours = Math.floor(this.video.duration / 60 / 60);
    var minutes = Math.floor(this.video.duration / 60);

    this.IonDateTimeHourValues = Array.from(Array(hours + 1).keys());
    this.IonDateTimeMinuteValues = Array.from(Array(minutes + 1).keys());
  }

  resetPreview(): Promise<void>{

    return new Promise<void>((resolve) => {
      this.clearPreview();

      setTimeout(() => {
        //FIRST TIMEOUT IS TO MAKE SURE THAT ANGULAR CLEARS THE A-SCENE FROM THE DOM
        this.previewReady = true;
        this.previewLoading = true;
        resolve();
      },200);
    });
  }

  setPreviewVRSceneBackground(): Promise<void>{
    return new Promise<void>((resolve) => {
      setTimeout(() => {
        if(this.scene.sceneBackgroundFileType == 'Image')
          this.previewBackground = '#background-image';
        else
          this.previewBackground = '#background-video';
        
        //SETS THE BACKGROUND IN THE PREVIEW A-SCENE
        let videoSphere = document.querySelector('#preview-sky');
        videoSphere.setAttribute('material', 'color: #ffffff; src: ' + this.previewBackground);

        resolve();
      },300);
    });
  }

  takeScreenshot(){
    setTimeout(() => {
      try{
        this.previewLoading = false;

        //SETS THE CAMERA POSITION
        this.authorService.moveCameraTo(0, 360 - Number(this.sceneYRot), 'preview-scene-settings');
        setTimeout(() => {
          let container = document.querySelector('#preview-content');
          let aScene: any = container.querySelector('a-scene');
          let canvas = aScene.components.screenshot.getCanvas('equirectangular');
          let previewImageContainer = document.querySelector('#preview-image-container');
          previewImageContainer.innerHTML = "";
          previewImageContainer.appendChild(canvas);
        }, 300);
      }catch{
        this.takeScreenshot();
      }
    },3000);
  }

  clearPreview(){
    this.previewReady = false;
    this.previewLoading = false;
    let previewImageContainer = document.querySelector('#preview-image-container');
    if (previewImageContainer)
      previewImageContainer.innerHTML = "";
  }

  playVideo(){
    this.video.play();
    this.videoPlaying = true;
  }

  pauseVideo(){
    this.video.pause();
    this.videoPlaying = false;
  }

  videoEnded(){
    this.videoPlaying = false;
  }

  //=========================================
  // ========== MANAGE ACTIONS ==============
  getAssetName(sceneAssetRelationId: number): string {
    let asset = this.authorService.assetsInScene.find(a => a.toBeRemoved == false && a.sceneAssetRelation.sceneAssetRelationId == sceneAssetRelationId);
    if (asset)
      return asset.baseAsset.name;
    else
      return "";
  }

  getSceneName(sceneId: number): string {
    return this.authorService.scenes.find(s => s.sceneId == sceneId).name;
  }

  isObjectEventType(eventTypeId: number) {
    return this.vrEventService.isObjectEventType(eventTypeId);
  }

  isMediaEventType(eventTypeId: number) {
    return this.vrEventService.isMediaEventType(eventTypeId);
  }

  getEventTypes() {
    return this.vrEventTypeService.types;
  }

  getActiveAssetsInScene(): AssetInScene[] {
    return this.authorService.assetsInScene.filter(a => a.toBeRemoved !== true && a.sceneAssetRelation.sceneId == this.scene.sceneId);
  }

  getActiveScenes(): Scene[] {
    return this.authorService.scenes.filter(s => s.active == true);
  }

  getEventType(eventTypeId) {
    return this.vrEventTypeService.getType(eventTypeId);
  }

  timeOfEventChanged(event){
    let timeString = event.detail.value;
    let a = timeString.split(':');
    let seconds = (+a[0]) * 60 * 60 + (+a[1]) * 60 + (+a[2]); 

    this.sceneEvent.timeOfEvent = seconds;
  }

  editAction(index: number){
    this.currentEventIndex = index;
    this.sceneEvent = this.deepCopyService.deepCopy(this.currentSceneEvents[this.currentEventIndex]);
    this.setTimeOfEvent();
  }

  cancelAction() {
    this.resetSceneEvent();
  }

  deleteAction(index: number){
    this.currentSceneEvents.splice(index, 1);
  }

  saveAction() {
    let sceneEvents = this.currentSceneEvents;

    if (this.sceneEvent.eventTypeId <= 0 
      || !this.sceneEvent.linkedContentId || Number(this.sceneEvent.linkedContentId) <= 0)
      return;

    if (this.currentEventIndex >= 0) {
      sceneEvents[this.currentEventIndex] = this.deepCopyService.deepCopy(this.sceneEvent);
    } else {
      sceneEvents.push(this.deepCopyService.deepCopy(this.sceneEvent));
    }

    this.resetSceneEvent();
  }

  saveSceneActions(){
    this.scene.events = this.currentSceneEvents;

    this.goBack();
  }

  moveCamera(){
    if(this.moveCameraTimeout)
      clearTimeout(this.moveCameraTimeout);

    this.moveCameraTimeout = setTimeout(() => {
      this.authorService.moveCameraTo(0, 360 - Number(this.sceneYRot), 'author-scene');
    }, 500);
  }

  onBackgroundLoad(event) {
    this.setPreviewVRSceneBackground().then(() => {
      this.takeScreenshot();
    });
  }
}
